import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiRichTextSection' })(
  ({ brandColors, breakpoints, typography }) => ({
    text: {
      // ToDo: set this at the section level and/ or determine how to set font color
      paddingTop: typography.pxToRem(50),
      paddingBottom: typography.pxToRem(50),
      paddingLeft: typography.pxToRem(30),
      paddingRight: typography.pxToRem(30),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(22),
        paddingRight: typography.pxToRem(26),
        paddingTop: typography.pxToRem(34),
        paddingBottom: typography.pxToRem(34),
      },
    },
    offWhiteBackground: {
      backgroundColor: brandColors.offWhite,
    },
    mediumBlueBackground: {
      backgroundColor: brandColors.mediumBlue,
      color: brandColors.offWhite,
    },
    blueGradientBackground: {
      background: `linear-gradient(180deg, ${brandColors.offWhite} 0%, ${brandColors.chargeBlue} 100%)`,
    },
    transparentBackground: {
      background: `transparent`,
    },
  })
);

export default useStyles;
